import './features.css'

interface FeatureCardProps {
    icon: string
    title: string
    description: string
    accent: string
}

function FeatureCard({ icon, title, description, accent }: FeatureCardProps) {
    return (
        <article className="feature-card" style={{ '--card-accent': accent } as React.CSSProperties}>
            <div className="feature-card__icon" aria-hidden="true">{icon}</div>
            <h3 className="feature-card__title">{title}</h3>
            <p className="feature-card__desc">{description}</p>
        </article>
    )
}

const FEATURES: FeatureCardProps[] = [
    {
        icon: '🧾',
        title: 'Facturas electrónicas SRI',
        description: 'Emite comprobantes autorizados por el SRI en ambientes de pruebas y producción. Soporte para RIMPE y obligados a llevar contabilidad.',
        accent: '#7df0ff',
    },
    {
        icon: '↩️',
        title: 'Notas de crédito',
        description: 'Anula facturas de forma automática: la app genera la nota de crédito correspondiente con un solo clic.',
        accent: '#ff82a9',
    },
    {
        icon: '🛒',
        title: 'Sistema de ventas (POS)',
        description: 'Selecciona productos por grupos, busca por nombre y acepta 8 métodos de pago: efectivo, tarjeta de crédito, débito, dinero electrónico y más.',
        accent: '#82ffc7',
    },
    {
        icon: '📦',
        title: 'Gestión de productos',
        description: 'Catálogo con grupos organizados. Permite productos con el mismo nombre pero diferente costo para mayor flexibilidad.',
        accent: '#ffb27a',
    },
    {
        icon: '👥',
        title: 'Roles y trabajadores',
        description: 'Crea cajeros, administradores y colaboradores con permisos granulares: ventas, productos, detalle de ventas y gestión de empleados.',
        accent: '#d8b4ff',
    },
    {
        icon: '🏢',
        title: 'Multi-establecimiento',
        description: 'Administra varios establecimientos y puntos de emisión desde una sola cuenta. Cambia entre ellos sin cerrar sesión.',
        accent: '#7df0ff',
    },
    {
        icon: '📡',
        title: 'Funciona sin internet',
        description: 'La app opera en modo offline con base de datos local. Para que puedas guardar tus documentos y enviarlos al SRI cuando recuperes la conexión.',
        accent: '#82ffc7',
    },
    {
        icon: '✍️',
        title: 'Firma electrónica',
        description: 'Carga tu firma digital (.p12) directamente desde la app. El primer uso es gratuito mediante el sistema de tokens.',
        accent: '#ffb27a',
    },
]

export default function Features() {
    return (
        <section className="features-section" id="caracteristicas" aria-labelledby="features-heading">
            <div className="features-header">
                <p className="features-eyebrow">¿Qué incluye?</p>
                <h2 className="features-heading" id="features-heading">Todo lo que necesitás para facturar</h2>
                <p className="features-subheading">
                    Funcionalidades reales, verificadas directamente en la app. Sin promesas vacías.
                </p>
            </div>
            <div className="features-grid">
                {FEATURES.map((feat) => (
                    <FeatureCard key={feat.title} {...feat} />
                ))}
            </div>
        </section>
    )
}
